import React, { useState, useContext, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LocaleContext from './contexts/locale.js'
import { Container, Row, Col, Button, Modal, Form, Nav, Tab, InputGroup } from 'react-bootstrap';
import { translate } from 'react-polyglot'
import { useParams } from "react-router-dom"

import DomainContext from './contexts/domainContext'

import ModalBaseObject from "../components/ModalBaseObject"
import AlertSection from "../components/AlertSection.js"
import ElementFormMedia from "../components/FormMedia.js"

import { getSelectedElement, checkComponentPresence, compareName} from "../util/ui_utils.js"


import { addProduct as addProduct2, editProduct as editProduct2, deleteProduct as deleteProduct2 } from '../Firebase2/Storage2/dbWarehouse';
import { addCatalogProduct, editCatalogProduct} from '../Firebase2/Storage2/dbCatalogWarehouse';
import { editFileTracker as editFileTracker2 } from '../Firebase2/Storage2/dbFileStorage.js';


const companyId = '0'
//const contractId = sessionStorage.getItem('contractId')

const section = 'cart'

////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//
////////////////////////////////////////////////////////////////////////////////////////////////////////
function ModalCart({ item, setItem, t, is_new, small, item_list, index, canWrite, ui_list, setUiList   }) {
	const { domain } = useContext(DomainContext)

	const childRefAlert = useRef()

	let { cid } = useParams();
	let contractId = cid

	const newcart = {
		code: '',
		brand: {},
		note: '',
		color_code_use: {},
		size_w: 0,
		size_h: 0,
		size_d: 0,
		composition_list: [],
		document_list: [],
		media_list: []
	}

	const [showEdit, setShow] = useState(false)
	const [curElement, setCurrentElement] = useState(newcart)
	const [editedElement, setEditedElement] = useState(false)

	const initValues = async () => {
//		const brand_list =  await getBaseObjectTypeList2(domain, 'brands')
//		const category_list = await getBaseObjectTypeList2(domain, 'cart_category')
//		setUiList({ ...ui_list, brand_list, category_list })
		/* 		let newelement_list = await getCartList(contractId, companyId, 'cart', null)
				newelement_list.sort(compareName)
				setElementList(newelement_list) */
	}

	const onUpdateData = (data, b) => {
		//DEBUG: console.log("onUpdateData. DATA:", data, "   B: ", b)
		setUiList({ ...ui_list, [data]: b.list })
	}


	const handleShowNew = () => {
		newcart.media_list = []
		setCurrentElement(newcart)
		setShow(true)
		setEditedElement(false)
	}

	const handleShowEdit = () => {
		setCurrentElement(item)
		setShow(true)
		setTimeout(function () {
			setEditedElement(false)
		}, 500)
	}


	const onChangeHandler = (el) => {
		console.log(el)
		let { name, value, type } = el
		if (type === 'radio') {
			if (value === 'true') {
				value = true
			} else if (value === 'false') {
				value = false
			}
		} else if (type === 'checkbox') {
			let oldcheck = curElement[name]
			if (el.checked) {
				if (oldcheck.indexOf(value) < 0) {
					oldcheck.push(value)
				}
			} else {
				if (oldcheck.indexOf(value) >= 0) {
					oldcheck.splice(oldcheck.indexOf(value), 1)
				}
			}
			value = oldcheck
		}
		console.log(name, value)
		setCurrentElement({ ...curElement, [name]: value })
		setEditedElement(true)
	}

	useEffect(() => {
		initValues()
	}, [])



	const handleClose = () => setShow(false);

	const handleSave = async () => {
		console.log("____________________________________SAVE_____________________________", is_new)
		let return_data
		if (is_new) {
			if (domain ==='catalog'){
				return_data =  await addCatalogProduct(contractId, section, curElement)
			}else{
				return_data =  await addProduct2(domain, contractId, companyId, section, curElement)
			}
			console.log(return_data)
			if (return_data && return_data.error) {
				childRefAlert.current.addAlert('danger', t('global.amessages.error') + return_data.error)
			} else {
				let newlist = [...item_list]
				newlist.push(return_data)
				setItem(newlist)
				setShow(false);
			}
		} else {
			if (domain ==='catalog'){
				return_data =  await editCatalogProduct(contractId, section, curElement.id, curElement)
			}else{
				return_data =  await editProduct2(domain, contractId, companyId, section, curElement.id, curElement)
			}
			console.log("edit", return_data)
			if (return_data && return_data.error) {
				childRefAlert.current.addAlert('danger', t('global.amessages.error') + return_data.error)
			} else {
				for (let m = 0; m < curElement.media_list.length; m++) {
					let editTrackData = curElement.media_list[m].tracker
					editTrackData.item_reference = { category: curElement.category, name: curElement.name, id: curElement.id }
					console.log("-----edit media----", editTrackData)
					let return_data = await editFileTracker2(domain, contractId, editTrackData.id, editTrackData)
				}
				console.log(item_list)
				let edit_list = [...item_list]
				const c = checkComponentPresence(curElement, item_list, 'id')
				edit_list.splice(c, 1, curElement)
				setItem(edit_list)
				setShow(false);
			}
		}
	}

	return (
		<>
			{is_new ?
				(small ?
					<Button onClick={() => handleShowNew()} variant="outline-primary"><FontAwesomeIcon icon='plus-square' /> </Button>
					:
					<Button onClick={() => handleShowNew()}><FontAwesomeIcon icon='plus-square' /> {t('cart.buttons.cart_add')}</Button>
				)
				: <Button className="me-1" variant="info" size="sm" onClick={() => handleShowEdit()}><FontAwesomeIcon icon="pencil-alt" /> </Button>
			}
			<AlertSection ref={childRefAlert} />
			<Modal show={showEdit} onHide={handleClose} className="bg-secondary" size="xl">
				<Modal.Header closeButton className={editedElement ? "bg-warning" : ""} >
					<Modal.Title>

						{is_new ?
							<>
								<FontAwesomeIcon icon="plus-square" /> <span className="text-primary">{t('carts.labels.new_cart')}</span>
							</>
							:
							[canWrite ?
								<>
									<FontAwesomeIcon icon="pencil-alt" /> <span className="text-info">{t('carts.labels.edit_cart')}</span>
								</>
								:
								<>
									<FontAwesomeIcon icon="info" /> <span className="text-info">{t('carts.labels.view_cart')}</span>
								</>
							]
						}
                        : {curElement.name}&nbsp;
                        {editedElement ? <FontAwesomeIcon icon="save" /> : ''}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Container fluid>
						<Tab.Container id="left-tabs-example" defaultActiveKey="tabDetails">
							<Row>
								<Col sm={3}>
									<Nav variant="pills" className="flex-column">
										<Nav.Item variant="secondary">
											<Nav.Link variant="secondary" eventKey="tabDetails" className="mb-1">{t('carts.labels.details')} </Nav.Link>
										</Nav.Item>
										{/* <Nav.Item>
											<Nav.Link variant="secondary" eventKey="tabComposition" className="mb-1">{t('carts.labels.composition')} </Nav.Link>
										</Nav.Item> */}
										<Nav.Item>
											<Nav.Link variant="secondary" eventKey="tabMedia" className="mb-1">{t('carts.labels.imagesdocs')} </Nav.Link>
										</Nav.Item>
									</Nav>
								</Col>
								<Col sm={9}>
									<Tab.Content>
										<Tab.Pane eventKey="tabDetails">
											<ElementFormDetails element={curElement} t={t} ui_list={ui_list} functions={{ edit: onChangeHandler, updateData: onUpdateData }} canWrite={canWrite} />
										</Tab.Pane>
										{/* 										<Tab.Pane eventKey="tabComposition">
											<ElementGoodListForm element={curElement} t={t} functions={{ edit: onChangeHandler }} />
										</Tab.Pane> */}
										<Tab.Pane eventKey="tabMedia">
											<ElementFormMedia element={curElement} t={t} ui_list={ui_list} functions={{ edit: onChangeHandler }} section={section} canWrite={canWrite} />
										</Tab.Pane>

									</Tab.Content>
								</Col>
							</Row>
						</Tab.Container>
					</Container>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						{t('modal.close')}
					</Button>
					{canWrite ?
						<Button className={editedElement ? "btn-warning" : "btn-primary"} form="companyForm" onClick={handleSave}>
							<FontAwesomeIcon icon="save" /> {t('modal.save')}
						</Button>
						: ''}
				</Modal.Footer>
			</Modal>
		</>
	)
}


////////////////////////////////////////////////////////////////////////////////////////////////////////
function ElementFormDetails({ element, functions, t, ui_list, canWrite }) {
	const { locale } = useContext(LocaleContext)
	const updateBrands = (b) => {
		functions.updateData('brand_list', b)
	}

	return (
		<>
			<Form.Group as={Row} controlId="cartFirstName" className="border-bottom mb-1 pb-1">
				<Form.Label column sm="2">{t('carts.labels.model')}</Form.Label>
				<Col sm="8">
					<Form.Control type="text" name="name" defaultValue={element.name} onChange={(event) => functions.edit(event.currentTarget)} />
				</Col>
			</Form.Group>
			<Form.Group as={Row} controlId="cartCode" className="border-bottom mb-1 pb-1">
				<Form.Label column sm="2">{t('carts.labels.code')}</Form.Label>
				<Col sm="8">
					<Form.Control  type="text" name="code" defaultValue={element.code} onChange={(event) => functions.edit(event.currentTarget)} />
				</Col>
			</Form.Group>
			<Form.Group as={Row} controlId="formCartBrand" className="border-bottom mb-1 pb-1">
				<Form.Label column sm="2">{t('carts.labels.brand')}</Form.Label>
				<Col sm="8">
					<Form.Control as="select" defaultValue={element.brand.Id} name="brand" className="mb-2" onChange={(event) => functions.edit({ name: 'brand', type: 'select', value: getSelectedElement(event.target.value, ui_list.brand_list) })}  >
						<option value="-1">{t('products.labels.select_brand')}</option>
						{ui_list.brand_list
							? [Object(ui_list.brand_list).map((f, k) => (
								<option key={k} value={f.Id} >{f.name? f.name[locale]: '---'}</option>
							))]
							: ''
						}
					</Form.Control>
				</Col>
				<Col sm="2">
					{canWrite ?
						<ModalBaseObject is_new={true} small={true} cursection={{ name: 'brands', list: ui_list.brand_list }} t={t} functions={{ setCurSection: updateBrands }} />
						: ''}
				</Col>
			</Form.Group>
			<Form.Group as={Row} controlId="cartSize" className="border-bottom mb-1 pb-1">
				<Form.Label column sm="2">{t('carts.labels.size')}</Form.Label>
				<Col>
					<InputGroup>
						<Form.Control type="number" min="0" name="size_w" defaultValue={element.size_w} aria-label="size_w" onChange={(event) => functions.edit(event.currentTarget)} />
						
							<InputGroup.Text id="basic-addon1">cm</InputGroup.Text>
						
					</InputGroup>
					<Form.Text className="text-muted">
						{t('carts.labels.size_w')}
					</Form.Text>
				</Col>
				<Col>
					<InputGroup>
						<Form.Control type="number" min="0" name="size_h" defaultValue={element.size_h} onChange={(event) => functions.edit(event.currentTarget)} />
						
							<InputGroup.Text id="basic-addon1">cm</InputGroup.Text>
						
					</InputGroup>
					<Form.Text className="text-muted" >
						{t('carts.labels.size_h')}
					</Form.Text>
				</Col>
				<Col>
					<InputGroup>
						<Form.Control type="number" min="0" name="size_d" defaultValue={element.size_d} onChange={(event) => functions.edit(event.currentTarget)} />
						
							<InputGroup.Text id="basic-addon1">cm</InputGroup.Text>
						
					</InputGroup>
					<Form.Text className="text-muted" id="cartSize" value="">
						{t('carts.labels.size_d')}
					</Form.Text>
				</Col>
			</Form.Group>
			<Form Group as={Row} controlID="formCartColorCode" className="border-bottom mb-1 pb-1">
				<Form.Label column sm="2">{t('carts.labels.color_code_use')} </Form.Label>
				<Col>
					<Form.Check value="dusting" type="checkbox" name="color_code_use" id="color_code_use_dust" custom label={t('carts.labels.color_dusting')} onChange={(event) => functions.edit(event.currentTarget)} />
				</Col>
				<Col>
					<Form.Check value="wash" type="checkbox" name="color_code_use" id="color_code_use_wash" custom label={t('carts.labels.color_wash')} onChange={(event) => functions.edit(event.currentTarget)} />
				</Col>
			</Form>
			<Form.Group as={Row} controlId="cartNote" className="border-bottom mb-1 pb-1">
				<Form.Label column sm="2">{t('carts.labels.note')}</Form.Label>
				<Col sm="8">
					<Form.Control type="text" name="note" defaultValue={element.node}  onChange={(event) => functions.edit(event.currentTarget)} />
				</Col>
			</Form.Group>
		</>
	)
}







export default translate()(ModalCart)